import styled, { css } from "styled-components";
import { ButtonTag } from '../Button/styles';
import MockUser from '../../assets/img/avatar.jpg';
import MockUserInner from '../../assets/img/avatar_inner.jpg';

export const UserContainer = styled.div`
  position: relative;
  margin-bottom: 15px;
  
  a {
    display: flex;
    align-items: center;
    color: inherit;
  }
  
  &:hover [data-dropdown] {
    opacity: 1;
    
    user-select: auto;
    pointer-events: auto;
  }
  
  @media(min-width: 1024px) {
    margin-bottom: 0;
    margin-left: 75px;
  }
`;

export const UserDropdown = styled.div`
  position: absolute;
  z-index: 10;
  right: 0;
  bottom: 0;
  transform: translateY(100%);
  
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  overflow: hidden;
  
  opacity: 0;
  user-select: none;
  pointer-events: none;
  
  transition: opacity 0.3s;
`;

export const Avatar = styled.div`
  position: relative;
  
  width: 40px;
  height: 40px;
    
  font-size: 0;
  
  overflow: hidden;
  border-radius: 50%;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    
    &::after {
      content: "";
      
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      
      width: 100%;
      height: 100%;
      
      border-radius: 50%;
      background: transparent no-repeat center / contain;
      background-image: ${({ isInnerPage }) => `url(${isInnerPage ? MockUserInner : MockUser})`};
    }
  }
`;

export const UserName = styled.p`
  margin-left: 15px;
  
  font-size: 16px;
  line-height: 1;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 40px;
  
  ${({ isOpen }) => isOpen && css`
    margin-bottom: 50px;
    margin-left: 0;
  `}; 
`;

export const LoginButton = styled(ButtonTag)`
  margin-right: 25px;
  padding: 13px 40px;
  
  &:hover {
    color: ${({ theme }) => theme.white};
    
    background-image: linear-gradient(159.02deg, #2DB9FE 0%, #4EDBFC 100%);
    box-shadow: 0 8px 20px rgba(30,182,255,0.24);
  }
  
  ${({ isInnerPage, theme }) => isInnerPage && css`
    &:hover {
      color: ${theme.blue};
            
      background-image: none;
      box-shadow: inset 0 0 0 2px ${theme.blue};
    }
  `}
  
  ${({ isOpen, theme }) => isOpen && css`
    &:hover {
      color: ${theme.white};
      
      background-image: linear-gradient(159.02deg, #2DB9FE 0%, #4EDBFC 100%);
      box-shadow: 0 8px 20px rgba(30,182,255,0.24);
    }
  `}
`;

export const SignUpButton = styled.button`
  margin: 0;
  padding: 0;
  
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.white};
  
  background-color: transparent;
  border: none;
  outline: none;
  
  cursor: pointer;
  
  transition: color 0.3s;
  
  ${({ isInnerPage, theme }) => isInnerPage && css`
    color: ${theme.blue};
  
    &:hover {
      color: ${theme.black};
    }
  `}
  
  ${({ isOpen, theme }) => isOpen && css`
    color: ${theme.white};
  
    &:hover {
      color: currentColor;
    }
  `}
`;
